// @flow
import React from "react";
import { useToggle } from "hooks";
import { type LockResultDTO } from "data/types";
import Avatar from "components/User/Avatar";
import Icons from "@hs/icons";
import loc from "i18next";
import styles from "./LockInfo.module.css";
import CloseButton from "components/ModalCloseButton";
import { getClassNames } from "data/utils";

export const LockInfoOn = ({ date }) => (
    <div className={styles.info}>
        <Icons.Locked height={14} className={styles.icon} />
        {loc.t("common:act.changes_locked", { date })}
    </div>
);

const LockInfo = ({
    lockInfo,
    className,
}: {
    lock: LockResultDTO,
    className?: string,
}) => {
    const [show, toggle] = useToggle(true);
    return (
        <div
            className={getClassNames(
                styles.wrapper,
                show ? styles.show : styles.noshow,
                className
            )}
        >
            {show && (
                <CloseButton onClick={toggle} className={styles.closeButton} />
            )}
            <Avatar
                id={lockInfo.lockedById}
                title={lockInfo.lockedByName}
                className={styles.avatar}
            />
            {lockInfo.lockedByName} <LockInfoOn date={lockInfo.lockedDate} />
        </div>
    );
};
LockInfo.displayName = "LockInfo";
export default LockInfo;
